var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgOpBackdrop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 106,
    viewBox: "0 0 106 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4760_14596)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.0628 70C30.2238 70 27.0805 69.0933 24.6328 67.2798C22.2109 65.4404 21 62.7979 21 59.4041C21 58.6788 21.0773 57.8238 21.2319 56.7876C21.6441 54.456 22.2367 51.658 23.0097 48.3679C25.1997 39.456 30.868 35 39.9887 35C42.4622 35 44.7037 35.4145 46.6618 36.2694C48.62 37.0725 50.1659 38.3161 51.2995 39.9741C52.4332 41.6062 53 43.5492 53 45.8031C53 46.4767 52.9227 47.3316 52.7681 48.3679C52.2786 51.2435 51.7118 54.0674 51.0161 56.7876C49.8824 61.2176 47.9501 64.5596 45.1675 66.7617C42.4106 68.9378 38.7005 70 34.0628 70ZM34.7585 63.0052C36.562 63.0052 38.0821 62.4611 39.3446 61.399C40.6329 60.3368 41.5604 58.7047 42.1014 56.4767C42.8486 53.4197 43.4155 50.7772 43.8019 48.4974C43.9308 47.8238 44.008 47.1244 44.008 46.399C44.008 43.4456 42.4879 41.9689 39.4219 41.9689C37.6184 41.9689 36.0725 42.513 34.7842 43.5751C33.5217 44.6373 32.62 46.2694 32.0789 48.4974C31.4863 50.6736 30.9195 53.3161 30.3269 56.4767C30.1981 57.1244 30.1208 57.7979 30.1208 58.5233C30.095 61.5285 31.6667 63.0052 34.7585 63.0052Z",
    fill: "url(#paint0_linear_4760_14596)",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.0008 70C54.6392 70 54.3809 69.8965 54.1743 69.6636C54.0194 69.4049 53.9677 69.1202 54.0194 68.7839L60.7085 37.2161C60.7601 36.8539 60.9409 36.5693 61.2508 36.3364C61.5349 36.1035 61.8448 36 62.1806 36H75.0681C78.658 36 81.5247 36.7504 83.6942 38.2253C85.8895 39.726 87 41.8737 87 44.6941C87 45.4962 86.8967 46.3501 86.7159 47.2298C85.9153 50.9559 84.2882 53.6986 81.8088 55.484C79.3811 57.2694 76.0495 58.1492 71.8139 58.1492H65.2798L63.0587 68.7839C62.9812 69.1461 62.8263 69.4307 62.5163 69.6636C62.2322 69.8965 61.9223 70 61.5866 70H55.0008ZM72.1497 51.4475C73.5185 51.4475 74.6807 51.0852 75.6879 50.3349C76.721 49.5845 77.3925 48.5236 77.7282 47.1263C77.8315 46.583 77.8832 46.0913 77.8832 45.6773C77.8832 44.7458 77.5991 44.0213 77.0567 43.5297C76.5144 43.0122 75.5588 42.7534 74.2416 42.7534H68.4306L66.597 51.4475H72.1497Z",
    fill: "url(#paint1_linear_4760_14596)",
    fillOpacity: 0.1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4760_14596",
    x1: 37,
    y1: 35,
    x2: 37,
    y2: 70,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4760_14596",
    x1: 70.5,
    y1: 36,
    x2: 70.5,
    y2: 70,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4760_14596"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 106,
    height: 106,
    rx: 53,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpBackdrop);
export default __webpack_public_path__ + "static/media/opBackdrop.fa5216696a2b3937b778a98b6f74bf2f.svg";
export { ForwardRef as ReactComponent };